import { IProductDataV1, Product } from '@df/catalog/product/product';
import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsHotspots {
    export const ID = 'hotspots';

    export interface IComponentData extends IHotspots, NICmsContentComponent.IData {
        components: NICmsContentComponent.IData[];
    }

    export interface IHotspots {
        hotspots: IHotspot[];
        hotspotsVisibility: EVisibility;
    }

    export interface IHotspot {
        product: number;
        productModel?: Product<IProductDataV1>;
        productImage: boolean;
        productPrice: boolean;
        image?: string;
        content: string;
        ctaText: string;
        ctaLink: string;
        top: number;
        left: number;
    }

    export enum EVariant {
        Details = 'details',
        Feature = 'feature'
    }

    export enum EVisibility {
        Always = 'always',
        Hover = 'hover'
    }
}
